import { createContext } from 'react'
import type { SiteContent } from './schema'

export interface ContentContextValue {
  content: SiteContent
  /** False until the first fetch settles; the site renders defaults meanwhile. */
  isLoaded: boolean
  /**
   * Re-reads the stored overrides, so an admin save shows on the live site
   * without a reload.
   */
  refresh: () => Promise<void>
}

/**
 * Split from the provider so consuming the context never pulls the
 * provider's module graph in, and Fast Refresh stays happy.
 */
export const ContentContext = createContext<ContentContextValue | null>(null)
